export default __webpack_public_path__ + "static/homeOG-006a04b9be6c43e5746525b738c4e50d.jpg";